import { Button, Checkbox, Form, Input, message, Modal, Spin, Tabs } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useCallback, useEffect, useState } from 'react';
import { ModalTitle } from '../../../components/text/Titles';
import { addModelVersion, getModelsForAlgorithm } from '../../../lib/api/algorithm-api';
import { Model } from '../../../types';
import { ModelRow } from './ModelRow';
const { TabPane } = Tabs;

type PretrainedModel = Partial<Model>;
type Props = {
  visible: boolean;
  onClose: () => any;
  algorithm: any;
  algorithmId: number;
};

export const ManageModels = ({ visible, onClose, algorithm, algorithmId }: Props) => {
  const [models, setModels] = useState<(Model | PretrainedModel)[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [form] = useForm();

  const fetchModels = useCallback(
    async (load: boolean) => {
      if (load) setLoading(true);
      const models = await getModelsForAlgorithm(algorithm.id);
      const pretrainedModels = models.filter(model => !model.lastModelVersionId);
      pretrainedModels.map(model => model.pretrained === true);
      if (load) setLoading(false);
      return setModels(pretrainedModels);
    },
    [algorithm, setModels]
  );

  useEffect(() => {
    fetchModels(true);
  }, [fetchModels]);

  const onAddVersion = useCallback(
    async values => {
      if (algorithmId) {
        const response = await addModelVersion(algorithmId, values.name, values.pretrained, values.version);
        if (response.status === 201) {
          message.success('New version created.');
          form.resetFields();
          fetchModels(false);
        }
      }
    },
    [form, algorithmId, fetchModels]
  );

  return (
    <>
      <Modal
        title={<ModalTitle>Manage models</ModalTitle>}
        visible={visible}
        onCancel={onClose}
        footer={false}
        bodyStyle={{ paddingTop: 12 }}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Models" key="1">
            {loading ? (
              <div className="w-full h-12 flex justify-center items-center">
                <Spin />
              </div>
            ) : (
              models.map(model => (
                <ModelRow key={model.id} model={model} fetchModels={fetchModels} algorithmId={algorithmId} />
              ))
            )}
          </TabPane>
          <TabPane tab="Add new version" key="2">
            <Form form={form} initialValues={{ pretrained: true }} layout="vertical" onFinish={onAddVersion}>
              <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please input a name!' }]}>
                <Input />
              </Form.Item>
              <Form.Item
                label="Version"
                name="version"
                rules={[{ required: true, message: 'Please input a version!' }]}>
                <Input />
              </Form.Item>
              <Form.Item name="pretrained" valuePropName="checked">
                <Checkbox>Pretrained</Checkbox>
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 20 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>
      </Modal>
    </>
  );
};
